import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Container, Form, Button, Card, Alert } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import config from '../config';
import './Auth.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  const handleGoogleLogin = () => {
    const callback = `${window.location.origin}/`;
    window.location.href = `${config.API_BASE}/api/connect/google?callback=${encodeURIComponent(callback)}`;
  };

  const handleAppleLogin = () => {
    const callback = `${window.location.origin}/`;
    window.location.href = `${config.API_BASE}/api/connect/apple?callback=${encodeURIComponent(callback)}`;
  };

  return (
    <Container className="auth-container">
      <Card className="auth-card">
        <Card.Body>
          <Card.Title className="text-center mb-4">登入</Card.Title>

          {error && <Alert variant="danger">{error}</Alert>}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>電郵</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>密碼</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="w-100 mb-3"
              disabled={loading}
            >
              {loading ? '正在登入...' : '登入'}
            </Button>
          </Form>

          <div className="oauth-buttons">
            <Button
              variant="outline-secondary"
              className="w-100 mb-2"
              onClick={handleGoogleLogin}
            >
              <img src="https://www.google.com/favicon.ico" alt="Google" className="oauth-icon" />
              Google 登入
            </Button>
            <Button
              variant="outline-secondary"
              className="w-100"
              onClick={handleAppleLogin}
            >
              <span className="oauth-icon">🍎</span>
              Apple 登入
            </Button>
          </div>

          <div className="text-center mt-4">
            <p>
              沒有帳戶？<Link to="/register">註冊</Link>
            </p>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default LoginPage;
